import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { sellPolicyData } from "../addpolicy/sellpolicyData.model";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from "src/config/app.config";
import { DatastorageService } from "../datastorage.service";
import moment from "moment";
import { Router } from "@angular/router";
import { MESSAGE_CONSTS } from "../ValidationMessages";
import { Step } from "../core/step.model";
import { CustomErrorHandler } from "../core/custom-error-handler";
import { NxDialogService, NxModalRef } from "@allianz/ng-aquila/modal";
import { PolicyStatus } from "../core/policyStatus.model";

@Component({
  selector: "app-vehicledetails",
  templateUrl: "./vehicledetails.component.html",
  styleUrls: ["./vehicledetails.component.css"],
  standalone: false
})

export class VehicledetailsComponent implements OnInit {
  private _apiUrl: string;
  public inclusiveCoverage: number;
  public maxvehage: number;
  public maxvehageInDays: number;
  vehicleDetailForm: FormGroup;
  sellPolicyData: sellPolicyData = new sellPolicyData();
  clientId: number;
  userId: number;
  modelList = [];
  colorList = [];
  isExtend: boolean = false;
  isAged: boolean = false;
  maxInsured: boolean = false;
  vinNumber: any = null;
  expiryDateofExistingPolicy: Date;
  isAlreadySaled: boolean = false;
  isEnableAutoValidate: boolean = false;
  clientName: string;
  step: Step = new Step();
  maxDate: moment.Moment;
  @ViewChild("policySearchModal") templateRef: TemplateRef<any>;
  templateDialogRef: NxModalRef<any>;
  isUnitySearch: boolean;
  maxYearsEligible: string;
  selectedModel: any;
  vehicleAge: number = 0;
  policyStartDate: Date;
  selectedColor: any[];
  isSellCancelledPolicyAgain: boolean = false;
  lastavailDate: Date;
  CancellationApprovalPending: boolean = false;
  vehicleAgeInDays: number = 0;

  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,
    private dataService: DatastorageService,
    private router: Router,
    private customErrorHandler: CustomErrorHandler,
    public dialogService: NxDialogService
  ) {
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.clientName = localStorage.getItem("CLIENT_NAME");
    this._apiUrl = appConfig.baseUrl;
    this.maxvehage = appConfig.maxvehicleAge;
    this.maxYearsEligible = moment(
      new Date().setFullYear(new Date().getFullYear() - this.maxvehage)
    ).format("YYYY-MM-DD");
  }

  ngOnInit() {
    this.vehicleDetailFormBuild();
    this.getModels();
    this.getColors();
    this.getVehicleDetails();
    this.initializeNav(3);
    this.maxDate = moment();
  }

  initializeNav(compltedStep: number) {
    for (let i = 0; i <= compltedStep; i++) {
      this.step.stepNumber = i;
      this.step.completed = false;
      this.dataService.nextClick.next(this.step);
    }
  }

  vehicleDetailFormBuild() {
    this.vehicleDetailForm = new FormBuilder().group({
      vinChassisNo: [
        this.sellPolicyData.vinChassisNo,
        [Validators.required, Validators.pattern(MESSAGE_CONSTS.VIN_REGEX)],
      ],
      licensePlateNo: [
        this.sellPolicyData.licensePlateNo?.toUpperCase(),
        [Validators.pattern(MESSAGE_CONSTS.NUMBER_PLATE_REGEX)],
      ],
      model: [this.sellPolicyData.model, [Validators.required]],
      colorName: [this.sellPolicyData.colorName, [Validators.required]],
      vehicleSaleDate: [
        this.sellPolicyData.vehicleSaleDate,
        [Validators.required],
      ],
      variant: this.sellPolicyData.variant,
      invoiceDate: [
        {
          value: new Date(),
          disabled: true,
        },
        Validators.required,
      ],
      otherDetails: this.sellPolicyData.otherDetails,
      workshopId: null,
      clientId: this.clientId,
      policyStatusId: 1,
      ageOfVehicle: this.sellPolicyData.ageOfVehicle,
      brand: { value: this.clientName, disabled: true },
      effectiveDate: this.sellPolicyData.effectiveDate,
    });
  }

  get purchaseDate() {
    return this.vehicleDetailForm.get("vehicleSaleDate");
  }
  get VehicleDetailFormControls() {
    return this.vehicleDetailForm.controls;
  }

  getColors() {
    this.authService
      .get(this._apiUrl + "/api/v1/Colors?pageNumber=-1")
      .subscribe(
        (response) => {
          if (response) {
            this.colorList = response;
          }
        },
        (error) => {

        }
      );
  }

  getModels() {
    this.authService
      .get(this._apiUrl + "/api/v1/Models?pageNumber=-1")
      .subscribe(
        (response) => {
          if (response) {
            this.modelList = response;
          }
        },
        (error) => {

        }
      );
  }

  //While coming back to page load data
  getVehicleDetails() {
    let resp = this.dataService.getData();
    if (resp) {
      this.sellPolicyData = resp;
      this.vehicleDetailFormBuild();
    }
  }

  //Based on Model Inclusive(default coverage will change)
  onModelSelected(value: string) {
    this.selectedModel = this.modelList.filter((obj) => {
      if (
        obj.modelName.trim().toLowerCase() ==
        (value ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.inclusiveCoverage =
      this.selectedModel.length == 0
        ? null
        : this.selectedModel[0].modelWarrenty;
  }

  //On sale date change calculate vehicle age
  onVehicleSaleDateChange() {
    const saleDateValue = this.vehicleDetailForm.controls.vehicleSaleDate.value;
    if (!saleDateValue) return;

    const saleDate = moment(saleDateValue);
    const now = moment.utc();

    // Total difference in days
    this.vehicleAgeInDays = now.diff(saleDate, 'days');
    this.maxvehageInDays = 365 * this.maxvehage;

    // Difference in years and days
    const yearsDiff = now.diff(saleDate, 'years');
    const tempDate = saleDate.clone().add(yearsDiff, 'years');
    const extraDays = now.diff(tempDate, 'days');

    if (yearsDiff > 0) {
      this.vehicleAge = yearsDiff;
      if (extraDays > 0) {
        this.vehicleAge += 1;
      }
    } else {
      this.vehicleAge = extraDays > 0 ? 1 : 0;
    }

    // Update the form control
    this.vehicleDetailForm.patchValue({
      ageOfVehicle: this.vehicleAge,
    });
  }


  Vinchanged(e) {
    if (
      e.target.value != "" &&
      this.vehicleDetailForm.get("vinChassisNo").valid
    ) {
      this.resetForm();
      this.searchVinNumber(e.target.value);
    }
  }

  searchVinNumber(vin: any) {
    this.sellPolicyData = new sellPolicyData();
    this.isExtend, this.isAged, (this.isUnitySearch = false);
    //only set if policy is exists
    this.expiryDateofExistingPolicy == undefined;
    this.vinNumber = vin;
    //Search On Own Repository
    this.authService
      .post(this._apiUrl + `/api/v1/PolicyDetails/SearchVin`, vin)
      .subscribe(
        (data) => {
          if (data) {
            this.prefillPolicy(data);
          } else {
            this.searchUnity();
          }
        },
        (error) => {
          this.templateDialogRef?.close();
          this.customErrorHandler.handleError(error);
        }
      );
  }

  searchUnity() {
    this.authService
      .post(this._apiUrl + `/api/v1/Unity/SearchVin`, this.vinNumber)
      .subscribe(
        (response) => {
          if (response.success) {
            this.prefillPolicy(response.data);
          } else {
            this.templateDialogRef?.close();
            this.customErrorHandler.handleCustomInfo(response.responsemsg);
          }
        },
        (error) => {
          this.customErrorHandler.handleError(
            "Sorry!!Failed to auto fill data"
          );
          this.templateDialogRef?.close();
        }
      );
  }

  prefillPolicy(data) {
    this.templateDialogRef = this.dialogService.open(this.templateRef, {
      ariaLabel: "Search dialoge",
    });

    this.expiryDateofExistingPolicy = new Date(data.expiryDate);

    this.sellPolicyData = data;

    //bind color and model
    this.selectedModel = this.modelList.filter((obj) => {
      if (
        data.model &&
        obj.modelName.toLowerCase() == (data.model ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.selectedColor = this.colorList.filter((obj) => {
      if (
        obj.colorName.toLowerCase() ==
        (data.colorName ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.sellPolicyData.model =
      this.selectedModel.length == 0 ? null : this.selectedModel[0].modelName;
    this.sellPolicyData.colorName =
      this.selectedColor.length == 0 ? null : this.selectedColor[0].colorName;

    this.vehicleDetailFormBuild();
    //For recalculating vehicle age based on sale date
    if (this.sellPolicyData.vehicleSaleDate == undefined || this.sellPolicyData.vehicleSaleDate == null) {
      var maxinsuredage = 0;
    }
    else {
      this.onVehicleSaleDateChange();
      var insuredyeardiff = this.diffDate(new Date(data.vehicleSaleDate), new Date(data.expiryDate));
      maxinsuredage = insuredyeardiff.years;
    }
    if (data.model) this.onModelSelected(data.model);
    //to trigger validation
    this.vehicleDetailForm.markAllAsTouched();

    if (PolicyStatus.Cancel == data.policyStatusId) {
      this.isSellCancelledPolicyAgain = true;
      this.lastavailDate = new Date(data.updatedDate);
      // set expirydate into cancelled date inorderd to renew the policy
      this.expiryDateofExistingPolicy = this.lastavailDate;
    } else if (PolicyStatus.CancelationApprovalPending == data.policyStatusId) {
      this.CancellationApprovalPending = true;
    } else if (this.expiryDateofExistingPolicy >= new Date()) {
      //check vehicle policy is to Extend it or not
      this.isAged = false;
      this.isExtend = true;
      this.maxInsured = false;
    } else if (this.vehicleAgeInDays >= this.maxvehageInDays) {
      //incase of old vehicle which are not eligible for renewal
      this.isAged = true;
      this.isExtend = false;
      this.maxInsured = false;
    }
    //Incase if a vehicle is exhausted with maximum policy renewal
    else if (maxinsuredage >= this.maxvehage) {
      this.isAged = false;
      this.isExtend = false;
      this.maxInsured = true;
    } else {
      this.templateDialogRef.close();
    }
  }

  setEffectivePolicyStartDate() {
    // If inclusiveCoverage is undefined, determine it using model
    if (this.inclusiveCoverage === undefined) {
      this.onModelSelected(this.sellPolicyData.model);
    }

    const vehicleSaleDate = new Date(this.vehicleDetailForm.controls.vehicleSaleDate.value);

    // Calculate expiry date of existing policy if not already set
    if (this.sellPolicyData.expiryDate && !this.expiryDateofExistingPolicy) {
      const diff = this.diffDate(this.sellPolicyData.effectiveDate, this.sellPolicyData.expiryDate);
      const expiry = new Date(this.sellPolicyData.expiryDate);
      expiry.setFullYear(expiry.getFullYear() - diff.years);
      expiry.setDate(expiry.getDate() - diff.days); // Watch for underflow
      this.expiryDateofExistingPolicy = expiry;
    }

    if (!this.expiryDateofExistingPolicy) {
      // New policy
      this.policyStartDate = new Date(
        vehicleSaleDate.getFullYear() + this.inclusiveCoverage,
        vehicleSaleDate.getMonth(),
        vehicleSaleDate.getDate()
      );

      if (this.policyStartDate <= new Date()) {
        this.policyStartDate = new Date();
        //14 days of activation period in case of expired policies
        this.policyStartDate.setDate(this.policyStartDate.getDate() + 14);
      }
    } else {
      // Policy extension
      const today = new Date();
      if (this.expiryDateofExistingPolicy < today) {
        this.policyStartDate = today;
 //14 days of activation period in case of expired policies
        this.policyStartDate.setDate(this.policyStartDate.getDate() + 14);
      } else {
        this.policyStartDate = this.expiryDateofExistingPolicy;
      }
    }

    this.vehicleDetailForm.patchValue({
      effectiveDate: this.policyStartDate,
    });
  }


  extendPolicy() {
    /*to trigger validation*/
    this.vehicleDetailForm.markAllAsTouched();

    this.isExtend = false;
    this.isAged = false;
    this.maxInsured = false;
    this.templateDialogRef.close();
  }

  saveVehicleDetails() {
    this.setEffectivePolicyStartDate();

    this.sellPolicyData.vinChassisNo =
      this.vehicleDetailForm.get("vinChassisNo").value;
    this.sellPolicyData.licensePlateNo =
      this.vehicleDetailForm.get("licensePlateNo").value;
    this.sellPolicyData.model = this.vehicleDetailForm.get("model").value;
    this.sellPolicyData.colorName =
      this.vehicleDetailForm.get("colorName").value;
    this.sellPolicyData.vehicleSaleDate = new Date(
      moment(this.vehicleDetailForm.get("vehicleSaleDate").value).format(
        "YYYY-MM-DD HH:mm"
      )
    );
    this.sellPolicyData.variant = this.vehicleDetailForm.get("variant").value;
    this.sellPolicyData.invoiceDate = new Date(
      moment(this.vehicleDetailForm.get("invoiceDate").value).format(
        "YYYY-MM-DD HH:mm"
      )
    );
    this.sellPolicyData.otherDetails =
      this.vehicleDetailForm.get("otherDetails").value;
    this.sellPolicyData.clientId = this.clientId;
    this.sellPolicyData.workshopId = null;
    this.sellPolicyData.policyStatusId = 1;
    this.sellPolicyData.ageOfVehicle =
      this.vehicleDetailForm.get("ageOfVehicle").value;
    this.sellPolicyData.brand = this.vehicleDetailForm.get("brand").value;
    this.sellPolicyData.effectiveDate = new Date(
      moment(this.vehicleDetailForm.get("effectiveDate").value).format(
        "YYYY-MM-DD HH:mm"
      )
    );
    this.sellPolicyData.planId = null;
    this.sellPolicyData.price = null;
    this.sellPolicyData.gstPrice = null;
    this.dataService.setData(this.sellPolicyData);
    this.router.navigate(["/sellpolicy/customerdetails"]);

    this.step.stepNumber = 0;
    this.step.completed = true;
    this.dataService.nextClick.next(this.step);
  }

  resetForm() {
    this.isExtend = false;
    this.isAged = false;
    this.maxInsured = false;
    this.CancellationApprovalPending = false;
    this.isSellCancelledPolicyAgain = false;
    this.vehicleDetailForm.reset({
      vinChassisNo: this.vehicleDetailForm.get("vinChassisNo").value,
      brand: this.vehicleDetailForm.get("brand").value,
      invoiceDate: this.vehicleDetailForm.get("invoiceDate").value,
    });
  }

  closeModal() {
    this.vehicleDetailForm.reset({
      brand: this.vehicleDetailForm.get("brand").value,
      invoiceDate: this.vehicleDetailForm.get("invoiceDate").value,
    });
    this.templateDialogRef.close();
  }

  diffDate(startDate, endDate) {
    var b = moment(startDate),
      a = moment(endDate),
      out: any = {};
    let intervals: moment.unitOfTime.DurationConstructor[] = ["years", "days"];

    for (var i = 0; i < intervals.length; i++) {
      var diff = a.diff(b, intervals[i]);
      b.add(diff, intervals[i]);
      out[intervals[i]] = diff;
    }
    return out;
  }
}
